import React from "react";
import "./BodySite.css"
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, NavLink, Navigate } from "react-router-dom";
import PageTitles from "./PageTitles";


const TurnosZoonosisMenuContinuar = () => {
    const navigate = useNavigate();

    const clickHandler = (e) =>{
        navigate("/turnoszoonosis",{state: {id: e.split("|")[1], name: e.split("|")[0]}});
        
    }

    
    return (
        <>
       <div class="container text-center indexContent" >
       <PageTitles texto="Turnos" subtexto={"Zoonosis "+localStorage.getItem("Zoonozis-sel").split('-')[0]+"- Condiciones" }icono="./icon_header_turnos.svg" retorno="/turnoszoonosismenu"/>

           {/* <div class="row">
                <div class="col">
                    <h1 class="titleIndicator">
                    <img class="imgBackIcon" src="./back-go.svg" onClick={()=>{navigate("/turnoszoonosismenu")}}/>
                        Zoonosis - Pilar</h1>
                </div>
    </div>*/}
            <div class="row">
                <div class="col">
                <div className="buttonContainer">
                <button className="buttonInvertedClip" onClick={()=> clickHandler(localStorage.getItem("Zoonozis-sel"))}>Continuar</button>
                </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    &nbsp;
                </div>
            </div>
            <div className="row">
                <div className="col miniText">
                    <b>Condiciones:</b>
                </div>
            </div>
            <div className="row">
                <div className="col miniText">
              { localStorage.getItem("Zoonozis-sel").includes("Felino")?
              <div style={{textAlign:"justify",marginTop:"5px;"}}>
                <ul style={{listStyle:"circle"}}>
                <li style={{lineHeight:"15px",marginTop:"5px"}}>Felinos hembra deben ser mayores a 6 meses de edad. </li>
                <li style={{lineHeight:"15px",marginTop:"5px"}}> Haber transcurrido al menos 45 días luego de tiempo de parición. </li>
                <li style={{lineHeight:"15px",marginTop:"5px"}}> Felinos machos deben ser mayores a 8 meses de edad.</li>
                </ul>
              <br/>
              <ul style={{listStyle:"none"}}>
              <li  style={{lineHeight:"15px"}}>
              Una vez que ya tengas el turno, cuando debas asistir es importante y obligatorio que asistas con tu mascota teniendo en cuenta lo siguiente</li>
               </ul>
              <ol>
                <li  style={{lineHeight:"15px",marginTop:"5px!important"}}>Ayuno de 8hs de sólido y 4hs de líquido</li>
              <li style={{lineHeight:"15px",marginTop:"5px!important"}}>Llevar manta para la recuperación </li>
              <li style={{lineHeight:"15px",marginTop:"5px!important"}}>Concurrir con transportadora o caja de cartón con agujeros, con trapos propios para aminorar el estrés.
              </li>
              </ol>
              IMPORTANTE: La mascota será castrada mediante evaluación realizada por el veterinario del móvil/sede.
              </div>:""}
              {localStorage.getItem("Zoonozis-sel").includes("Macho")?
              <div style={{textAlign:"justify",marginTop:"5px;"}}>
              <ul style={{listStyle:"circle"}}>
              <li style={{lineHeight:"15px",marginTop:"5px!important"}}>Los caninos machos deben ser mayores a 6 meses de edad. </li>
              </ul>
            <br/>
            <ul style={{listStyle:"none"}}>
            <li  style={{lineHeight:"15px"}}>
            Una vez que ya tengas el turno, cuando debas asistir es importante y obligatorio que asistas con tu mascota teniendo en cuenta lo siguiente</li>
             </ul>
            <ol>
              <li  style={{lineHeight:"15px",marginTop:"5px!important"}}>Ayuno de 8hs de sólido y 4hs de líquido</li>
            <li style={{lineHeight:"15px",marginTop:"5px!important"}}>Llevar manta para la recuperación </li>
            <li style={{lineHeight:"15px",marginTop:"5px!important"}}>Collar y correa
            </li>
            </ol>
            IMPORTANTE: La mascota será castrada mediante evaluación realizada por el veterinario del móvil/sede.
            </div>
              :""}
                {localStorage.getItem("Zoonozis-sel").includes("Hembra")?
                  <div style={{textAlign:"justify",marginTop:"5px!important;"}}>
                  <ul style={{listStyle:"circle"}}>
                  <li style={{lineHeight:"15px",marginTop:"5px!important"}}>Los caninos hembras deben ser mayores a 6 meses de edad. </li>
                  <li style={{lineHeight:"15px",marginTop:"5px!important"}}>Haber transcurrido al menos 60 días luego de tiempo de parición. </li>
                  </ul>
                <br/>
                
                <span >
                Una vez que ya tengas el turno, cuando debas asistir es importante y obligatorio que asistas con tu mascota teniendo en cuenta lo siguiente</span>
                 
                <ol>
                  <li  style={{lineHeight:"15px",marginTop:"5px!important"}}>Ayuno de 8hs de sólido y 4hs de líquido</li>
                <li style={{lineHeight:"15px",marginTop:"5px!important"}}>Llevar manta para la recuperación </li>
                <li style={{lineHeight:"15px",marginTop:"5px!important"}}>Collar y correa
                </li>
                </ol>
                IMPORTANTE: La mascota será castrada mediante evaluación realizada por el veterinario del móvil/sede.
                </div>
                :""}
              
                </div>
            </div>
            
            
           
       </div>
        
        </>

    );
}

export default TurnosZoonosisMenuContinuar;